module.exports = __webpack_public_path__ + "static/media/fluoro-multi-enabled.e6f3b456.svg";